import { render, staticRenderFns } from "./KategorijeObjekata.vue?vue&type=template&id=2573dbf9&scoped=true&"
import script from "./KategorijeObjekata.vue?vue&type=script&lang=ts&"
export * from "./KategorijeObjekata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2573dbf9",
  null
  
)

export default component.exports